<template>
  <div class="px-3 main-wrapper bg-main">
    <div>
      <div class="mt-3">
        <h3 class="page-title">
          {{ $t("withdraw.withdraw_form") }}
        </h3>
      </div>
      <div
        class="error-box"
        v-if="error"
      >{{ error }}</div>

      <div
        class="text-danger error-box"
        v-if="authUser && authUser.turn_over_amount > 0"
      >
        <span class="mx-auto">
          {{ $t('withdraw.turn_over_error') }} <br />
          <strong>{{ authUser.turn_over_amount }}</strong>
        </span>
      </div>
      <div class="card-body bg-transparent">
        <form>
          <nav class="bank-card">
            <img
              class="edit-btn"
              @click="$router.push('/banking')"
              src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/edit.png"
              alt="Edit bank"
            />

            <div class="bank-info">
              <p class="bank-type">{{ bankInfo.type }}</p>
              <h3 class="bank-name">{{ bankInfo.name }}</h3>
              <p class="bank-account">
                {{ blurLastFiveCharacters(bankInfo.account_number) }}
              </p>
            </div>

            <div class="amount-box">
              <span class="amount-label">{{ $t("setting.balance") }}</span>
              <p class="balance-value">
                {{ Number($store.state.authUser.amount).toLocaleString() }}
                <span>฿</span>
              </p>
            </div>
          </nav>

          <div class="mt-4">
            <div class="form-group">
              <label class="label">{{ $t("withdraw.amount") }}&nbsp;&nbsp;</label>
              <span
                style="color: #ccc"
                class="text-xs"
              >{{
                $t("withdraw.minimum_deposit")
              }}</span>
              <input
                type="number"
                id="input-email"
                class="input"
                v-model="withdrawData.amount"
              />
              <span class="input-error">{{
                errors.amount
              }}</span>
            </div>
            <div class="form-group">
              <label class="label">{{ $t("withdraw.remark") }}</label>
              <textarea
                rows="4"
                class="input"
                v-model="withdrawData.remark"
              ></textarea>
            </div>
            <button
              type="button"
              class="submit-btn"
              @click="sendWithdrawData"
            >
              <div v-if="!isConfirm">{{ $t("withdraw.submit") }}</div>
              <Loading
                v-else
                size="24"
              />
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from "vant";
import { mapActions } from "vuex";
import AccountSelect from "./components/AccountSelect.vue";

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      authUser: null,
      imageUploader: [],
      selected_account: {
        account_id: null,
      },
      bankInfo: {},
      accounts: [
        {
          name: "KBZ pay",
          id: "KBZ pay",
          link: "https://cdn.gold549.com/build/assets/img/payments/kpay.png",
        },
        {
          name: "KBZ pay",
          id: "KBZ pay",
          link: "https://cdn.gold549.com/build/assets/img/payments/kpay.png",
        },
        {
          name: "KBZ Mobile Banking",
          id: "KBZ Mobile Banking",
          link: "https://cdn.gold549.com/build/assets/img/payments/kbz.png",
        },
        {
          name: "Wave pay",
          id: "Wave pay",
          link: "https://cdn.gold549.com/build/assets/img/payments/wavepay.png",
        },
        {
          name: "CB Pay",
          id: "CB Pay",
          link: "https://cdn.gold549.com/build/assets/img/payments/cb_pay.png",
        },
        {
          name: "CB Banking",
          id: "CB Banking",
          link: "https://cdn.gold549.com/build/assets/img/payments/cbbank.png",
        },
        {
          name: "AYA Pay",
          id: "AYA Pay",
          link: "https://cdn.gold549.com/build/assets/img/payments/ayapay.png",
        },
        {
          name: "AYA Banking",
          id: "AYA Banking",
          link: "https://cdn.gold549.com/build/assets/img/payments/aya.png",
        },
      ],
      account: [],
      imageUploader: [],
      withdrawData: {
        amount: 0,
      },
      errors: {},
      error: null,
      isConfirm: false,
    };
  },
  methods: {
    blurLastFiveCharacters(inputString = "0000000000") {
      // Get the length of the input string
      const length = inputString.length;

      // Check if the input string has at least five characters
      if (length >= 7) {
        // Extract the first part of the string
        const firstPart = inputString.substring(length - 5, length);

        // Create a string with '*' characters for the last five numbers
        const blurredCharacters = "*".repeat(length - 5);

        // Concatenate the first part and the blurred numbers
        const blurredString = blurredCharacters + firstPart;

        return blurredString;
      } else {
        // Return the input string unchanged if it has less than five characters
        return inputString;
      }
    },
    ...mapActions(["fetchUser"]),
    validateWithdraw() {
      this.error = null;
      const err = {};

      if (!this.withdrawData.amount) {
        err.amount = this.$t('withdraw.enter_amount');
      }

      if (this.withdrawData.amount < 100) {
        err.amount = this.$t('withdraw.enter_at_least');
      }

      this.errors = err;

      return Object.keys(err).length === 0;
    },
    async sendWithdrawData() {
      try {
        this.isConfirm = true;
        this.error = null;
        const authUser = await this.fetchUser();
        if (!this.validateWithdraw()) {
          Toast.fail("Failed!");
          this.isConfirm = false;
          return false;
        }

        if (this.withdrawData.amount > parseInt(authUser.amount)) {
          const balanceError = this.$t('withdraw.insufficient_balance');

          Dialog.alert({
            message: balanceError,
            confirmButtonText: this.$t('withdraw.go_back'),
          }).then(() => {
            // on close
          });
          this.isConfirm = false;
          return false;
        }

        this.$store.commit(
          "setAmount",
          (this.$store.state.amount -= this.withdrawData.amount)
        );

        if (this.imageUploader[0]) {
          this.withdrawData.transaction_image = this.imageUploader[0].content;
        }
        // this.withdrawData.type = this.selected_account.account_id;
        this.withdrawData.date = this.currentTime;
        this.withdrawData.account_number = this.bankInfo.account_number;
        this.withdrawData.account_name = this.bankInfo.name;
        this.withdrawData.type = this.bankInfo.type;
        this.withdrawData.lang = localStorage.getItem("language");
        this.withdrawData.user_id = this.$store.state.authUser.id;

        const res = await axios.post("/withdraws", this.withdrawData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        // console.log("RES", res);
        if (!res.data.success) {
          this.error = res.data.message || 'Something went wrong!'
          Dialog.alert({
            message: res.data.message,
            confirmButtonText: this.$t('withdraw.go_back'),
          }).then(() => {
            // on close
          });
          this.isConfirm = false;
          return;
        }

        this.imageUploader = [];
        this.withdrawData = {};
        this.selected_account.account_id = null;

        await this.fetchUser();
        Toast.success("Success");
        this.isConfirm = false;
      } catch (error) {
        Toast.fail("Fail");
        this.error = error.response.data;
        this.isConfirm = false;
      }
      return true;
    },
    createDateWithTimeZone() {
      const moment = require("moment-timezone");
      const dateInTimeZone = moment.tz(new Date(), "Asia/Rangoon");
      // Extract individual components from moment object
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();

      const newDateObject = new Date(
        year,
        month,
        day,
        hour,
        minute,
        second,
        millisecond
      );
      return newDateObject;
    },
  },
  //   watch: {
  //     'selected_account.account_id': function () {
  //       this.account = this.accounts.filter(
  //         (account) => account.id === this.selected_account.account_id,
  //       );
  //     },
  //   },
  computed: {
    currentTime() {
      return moment(this.createDateWithTimeZone()).format("lll");
    },
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    const authUser = await this.fetchUser();
    this.$store.commit('setLoading', false);
    if (!authUser) {
      this.$router.push("/auth/login");
      return;
    }

    this.authUser = authUser;
    if (authUser && authUser.turn_over_amount > 0) {
      Dialog.alert({
        message: `ငွေထုတ်ရန် လိုအပ်သော ကစားအားပမာဏ ${authUser.turn_over_amount}`,
        confirmButtonText:
          this.$store.state.language === "en" ? "Go Home" : "ပင်မစာမျက်နှာသို့",
      }).then(() => {
        this.$router.push("/");
      });
    }

    if (authUser && (!authUser.bank || !authUser.bank.account_number || !authUser.bank.name)) {
      this.$router.push("/banking");
    }
    this.bankInfo = authUser.bank;
  },
};
</script>
<style scoped>
.bank-card {
  position: relative;
  padding: 1.25rem 1rem;
  border-radius: 16px;
  background: linear-gradient(145deg,
      rgba(255, 255, 255, 0.08),
      rgba(255, 255, 255, 0.03));
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
}

/* Edit icon */
.edit-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  height: 20px;
  opacity: 0.7;
  cursor: pointer;
  transition: 0.2s ease;
}

.edit-btn:hover {
  opacity: 1;
  transform: scale(1.1);
}

/* Bank info */
.bank-info {
  text-align: center;
  margin-bottom: 1rem;
}

.bank-type {
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  color: #b8b6d8;
  text-transform: uppercase;
}

.bank-name {
  color: #ffffff;
  font-weight: 600;
  margin: 0.25rem 0;
}

.bank-account {
  font-size: 0.85rem;
  color: #9e9cc9;
}

/* Amount section */
.amount-box {
  background: rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  padding: 0.75rem;
  text-align: center;
}

.amount-label {
  font-size: 0.7rem;
  color: #9e9cc9;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.balance-value {
  margin-top: 0.25rem;
  font-size: 1.75rem;
  font-weight: 700;
  color: #ffb800;
}

.balance-value span {
  font-size: 1rem;
  opacity: 0.8;
}


.page-title {
  color: white;
  text-align: center;
  font-size: 22px;
  font-weight: 600;
}

.form-group {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.label {
  color: #fff;
  font-size: 1rem;
}

.input {
  width: 100%;
  padding: 12px 0;
  background: transparent;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  cursor: pointer;
}

.input-error {
  color: #ff7070;
  font-size: 12px;
}

.submit-btn {
  width: 100%;
  margin-top: 25px;
  padding: 14px;
  border-radius: 50px;
  background: linear-gradient(to right, #5A4BFF, #A557FF);
  color: white;
  font-size: 20px;
  border: none;
}

.image-container {
  width: 200px;
  height: 200px;
}

.image-container img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.number-container {
  border-radius: 5px;
  background: #e9ecef;
  justify-content: center;
}

.custom-file {
  height: auto;
}
</style>
